const USERS_URL = "/users";

export async function deleteUser(axiosPrivate, _id) {
  try {
    const response = await axiosPrivate.delete(`${USERS_URL}/${_id}`);
    return response;
  } catch (err) {
    console.error(err);
  }
}
